export const foldersData = [
  {
    title: 'Personal',
    unreadConversations: 0,
  },
  {
    title: 'Groups',
    unreadConversations: 0,
  },
];
